import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { ProductType } from "@b2bportal/core-types";
import type { SingleItineraryResponse } from "@b2bportal/rbc-activities-api";
import {
  ActivityReservationDetailContent,
  ActivityDetailsPanel,
  BookingDetailsSection,
  CheckoutBreakdownSection,
  ActivityBookingQuestionsSection,
} from "../components";
import styles from "./TripDetailContent.module.scss";
import { ManageBooking } from "@/components";
import { MyTripPageHeader } from "@/overrides/apac/apac-ui/components/MyTripPageHeader/MyTripPageHeader";

interface TripDetailContentProps {
  singleItinerary: SingleItineraryResponse;
  isActiveBooking: boolean;
  onQueryCancellation: () => void;
  children?: ReactNode;
}

export const TripDetailContent = ({
  singleItinerary,
  isActiveBooking,
  onQueryCancellation,
  children,
}: TripDetailContentProps) => {
  const [, cn] = useModuleBEM(styles, "TripDetailContent");
  const reservation = singleItinerary?.reservation;

  if (!reservation) {
    return null;
  }

  return (
    <>
      <MyTripPageHeader className={cn("page-header")} />
      <div className={cn("card-wrapper")}>
        <ActivityReservationDetailContent reservation={reservation} />

        <div className={cn("two-column")}>
          <ActivityDetailsPanel
            className={cn("activity-details")}
            reservation={reservation}
          />
          <ManageBooking
            className={cn("manage-booking")}
            variant={ProductType.ACTIVITIES}
            itinerary={reservation}
            isActiveBooking={isActiveBooking}
            onQueryCancellation={onQueryCancellation}
          />
          <BookingDetailsSection
            className={cn("booking-details")}
            reservation={reservation}
          />
          <ActivityBookingQuestionsSection
            className={cn("booking-questions")}
            reservation={reservation}
          />
          <CheckoutBreakdownSection
            className={cn("checkout-breakdown")}
            reservation={reservation}
            paymentBreakdown={singleItinerary.paymentBreakdown}
          />
        </div>
      </div>
      {children}
    </>
  );
};
